import { Provider } from '@angular/core';

export abstract class ModalHelperServiceBase {
  // shortcut to provide a subclass of ModalHelperServiceBase as ModalHelperServiceBase
  static provideAsBase(): Provider {
    return {
      provide: ModalHelperServiceBase,
      useExisting: this,
    };
  }

  abstract appendModalOverrideClass(_element: Element): void;
}
